import { addToast, Button, Icon, Modal } from '@octano/global-ui';
import { useCallback, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { useActionKitImp } from '../../../../components/ozmoit/common/action-kit-imp';
import { downloadFromBlob } from '../../../../utils/blob';
import { exportStudentsRiskHistoryAction } from './actions';
import { StudentsRiskHistoryLoader } from './hooks/StudentsRiskHistoryLoader';

export function DownloadButton() {
  const { query } = StudentsRiskHistoryLoader();
  const [showNoDataModal, setShowNoDataModal] = useState(false);

  const { action: handleExport, loading: exporting } = useActionKitImp(
    exportStudentsRiskHistoryAction,
    {
      onSuccess: () => {
        addToast({
          color: 'success',
          text: 'Listado descargado exitosamente',
        });
      },
      onError: {
        unknown: () => {
          addToast({
            color: 'danger',
            text: 'Error al descargar el listado',
          });
        },
      },
    },
  );

  const handlePressExport = useCallback(async () => {
    if (exporting || !query.schoolId || !query.year || !query.periodId) {
      return;
    }
    const response = await handleExport({
      schoolId: Number(query.schoolId),
      year: Number(query.year),
      periodId: Number(query.periodId),
    });
    console.log('response.data.data', response);

    if (!response.success) {
      return;
    }

    if ((response.data as File).size === 0) {
      setShowNoDataModal(true);
      return;
    }

    const blob = new Blob([response.data], {
      type: 'vnd.ms-excel',
    });
    downloadFromBlob(blob, 'historial-riesgo-estudiantes.xlsx');
  }, [handleExport, query, exporting]);

  return (
    <>
      <Row className="mt-3">
        <Col xs={12} className="d-flex justify-content-end">
          <Button
            text="Descargar listado"
            size="md"
            type="button"
            icon="download"
            loading={exporting}
            outlined
            onClick={handlePressExport}
          />
        </Col>
      </Row>

      <Modal isOpen={showNoDataModal} toggle={() => setShowNoDataModal(false)}>
        <div className="d-flex flex-column align-items-center text-center p-3">
          <Icon name="information" size={51} color="primary" />
          <h2 className="text-dark fs-20 mt-4 mb-4">Sin resultados</h2>
          <p className="mb-4">
            No se encontraron estudiantes en riesgo alto para los filtros
            seleccionados.
          </p>
          <Button
            className="w-100"
            type="button"
            size="md"
            fullwidth
            outlined
            text="Cerrar"
            onClick={() => setShowNoDataModal(false)}
          />
        </div>
      </Modal>
    </>
  );
}
